import React, { useState } from "react";
import PropTypes from "prop-types";
import CFSelect from "../shared/forms/CFSelect";

const MODES = [
  {
    value: "all",
    label: "Deliver all",
    description:
      "Each campaign delivers based on allocated traffic percentage. Campaigns can overlap.",
  },
  {
    value: "rotate",
    label: "Rotate campaigns",
    description:
      "Campaigns are randomly displayed, weighted by allocated percentage.",
  },
];

const BroadcastDeliveryMode = (props) => {
  const [mode, setMode] = useState(
    props.deliveryMode === "rotate" ? "rotate" : "all"
  );
  const [error, setError] = useState(false);

  async function selectMode(selected) {
    const newMode = selected.value;
    if (newMode === mode) return;

    const response = await fetch(props.url, {
      headers: {
        Accept: "text/javascript",
        "X-CSRF-Token": csrfToken(),
      },
      method: "PUT",
      body: new URLSearchParams({ "broadcast[delivery_mode]": newMode }),
    });

    if (response.ok) {
      setMode(newMode);
      setError(false);
      $("#broadcasts-ctas-table").attr("data-delivery-mode", newMode);
      $('form[data-type="broadcasts-cta-traffic"] .percentage').removeClass(
        "error"
      );
      broadcasts_ctas.update_control_hint();
    } else {
      setError(true);
    }
  }

  const selectedMode = MODES.find((option) => option.value === mode);

  return (
    <div className="row hard-center mt-4">
      <p className="field-title">Delivery mode</p>
      <div style={{ maxWidth: "300px" }}>
        <CFSelect
          options={MODES}
          value={selectedMode}
          onChange={selectMode}
          isSearchable={false}
        />
      </div>
      <p className="text-sm text-slate-500 mt-[5px]">
        {selectedMode.description}
      </p>
      {error && (
        <p className="text-xl" style={{ color: "#f17c69" }}>
          Reduce total traffic to 100% or less to rotate campaigns.
        </p>
      )}
    </div>
  );
};

BroadcastDeliveryMode.propTypes = {
  url: PropTypes.string.isRequired,
  deliveryMode: PropTypes.string,
};

export default BroadcastDeliveryMode;
